module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.$_onDropdownClose),
      expression: "$_onDropdownClose"
    }],
    class: _vm.wrapClasses,
    on: {
      "mouseenter": _vm.$_onDropdownMouseenter,
      "mouseleave": _vm.$_onDropdownMouseleave
    }
  }, [_c('div', {
    ref: "reference",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onDropdownClick($event)
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('t-pop-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentVisible),
      expression: "currentVisible"
    }],
    ref: "drop",
    attrs: {
      "placement": _vm.placement
    },
    nativeOn: {
      "mouseenter": function($event) {
        return _vm.$_onDropdownMouseenter($event)
      },
      "mouseleave": function($event) {
        return _vm.$_onDropdownMouseleave($event)
      }
    }
  }, [_vm._t("list")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4b9c1ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/dropdown.vue
// module id = 417
// module chunks = 0